import {
  MRT_RowData,
  MRT_RowSelectionState,
  MRT_TableInstance,
} from 'material-react-table';

type EntityWithId = {
  id: number | string;
};

export const getEntityRowId = <T extends EntityWithId>(row: T): string =>
  String(row.id);

export const getFilteredSelectedRows = <TData extends MRT_RowData>(
  table: Pick<MRT_TableInstance<TData>, 'getFilteredSelectedRowModel'>,
): TData[] =>
  table
    .getFilteredSelectedRowModel()
    .flatRows.filter((row) => row.getCanSelect())
    .map((row) => row.original);

export const getRowsFromSelection = <TData>(
  data: TData[],
  rowSelection: MRT_RowSelectionState,
  getRowId: (row: TData) => string,
): TData[] => data.filter((row) => rowSelection[getRowId(row)] === true);
